import type { ClientTaxDocumentation } from "@taxbit/react-sdk";

// W-9 box 2 is the one certification users can untick, and we can't backup withhold.
export const isSubjectToBackupWithholding = (data: ClientTaxDocumentation): boolean =>
  Boolean(data.accountHolder?.isUsPerson) && data.isNotSubjectBackupWithholding !== true;
